/**
 * List of existing Zone Sector's types.
 * * Zone
 * * Ark
 * * Special
 */
module.exports = {
	zone: 'zone',
	ark: 'ark',
	special: 'special'
};
